import { render, staticRenderFns } from "./SmogAlertor.vue?vue&type=template&id=57038e12&scoped=true"
import script from "./SmogAlertor.vue?vue&type=script&lang=js"
export * from "./SmogAlertor.vue?vue&type=script&lang=js"
import style0 from "./SmogAlertor.vue?vue&type=style&index=0&id=57038e12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57038e12",
  null
  
)

export default component.exports